import { key } from '@connect-x-app/shared-test-ids';

export const CHANNEL_TEST_IDS = {
  accessRequestModal: {
    approve: 'channel.accessRequestModal.button.approve',
    deny: 'channel.accessRequestModal.button.deny',
    selectAll: 'channel.accessRequestModal.button.selectAll',
  },
  bubble: {
    container: (sender: 'byMe' | 'byOther') => `channel.bubble.view.container.${sender}`,
  },
  channels: {
    customTab: 'channel.channels.button.customTab',
    customTabUnreadDot: 'channel.channels.view.customTabUnreadDot',
    item: (title: string) => `channel.channels.row.${key(title)}`,
    list: 'channel.channels.view.list',
    mainTab: 'channel.channels.button.mainTab',
    mainTabUnreadDot: 'channel.channels.view.mainTabUnreadDot',
    privateIcon: 'channel.channels.view.privateIcon',
    unreadDot: 'channel.channels.view.unreadDot',
  },
  empty: {
    selection: 'channel.empty.view.selection',
  },
  header: {
    grantAccess: 'channel.header.button.grantAccess',
    info: 'channel.header.button.info',
    locations: 'channel.header.view.locations',
    timeZone: 'channel.header.switch.timeZone',
  },
  input: {
    message: 'channel.input.input.message',
    uploadFile: 'channel.input.input.uploadFile',
  },
  mention: {
    options: 'channel.mention.view.options',
  },
  messages: {
    countdown: 'channel.messages.view.countdown',
    countdownValue: 'channel.messages.text.countdownValue',
    info: 'channel.messages.button.info',
  },
  preview: {
    viewChannel: 'channel.preview.button.viewChannel',
  },
  quickReplies: {
    modal: 'channel.quickReplies.modal.replies',
    showMore: 'channel.quickReplies.button.showMore',
  },
} as const;
